import Color from "../colors/Color";

import FlowNode from "./FlowNode";
import FlowNodeType from "./FlowNodeType";
import { FlowShapeType } from "./FlowShape";
import Position from "./Position";

interface FlowScreenNodeRequest {
    _id?: string;
    type: FlowNodeType.Screen;
    screen: string;
    position?: Position;
}

interface FlowTextLabelNodeRequest {
    _id?: string;
    type: FlowNodeType.TextLabel;
    text: string;
    width?: number;
    position: Position;
}

interface FlowShapeNodeRequest {
    _id?: string;
    type: FlowNodeType.Shape;
    text: string;
    position: Position;
    shapeType: FlowShapeType;
    width: number;
    height: number;
    color: Color;
}

interface FlowPlaceholderNodeRequest {
    _id?: string;
    type: FlowNodeType.Placeholder;
    text: string;
    position: Position;
    width: number;
    height: number;
}

interface FlowVariantGroupNodeRequest {
    _id?: string;
    type: FlowNodeType.VariantGroup;
    variantGroup: string;
    defaultVariant: string;
    position?: Position;
}

interface FlowAnnotationNodeRequest {
    _id?: string;
    type: FlowNodeType.Annotation;
    position: Position;
    fontSize: string;
    fontType: string;
    text: string;
    noteType?: string;
    width: number;
    height: number;
    hideSignature?: boolean;
    color?: Color;
    createdAt?: string;
    updated?: string;
    createdBy?: string;
    updatedBy?: string;
}

type FlowNodeRequest =
    FlowScreenNodeRequest |
    FlowTextLabelNodeRequest |
    FlowVariantGroupNodeRequest |
    FlowShapeNodeRequest |
    FlowPlaceholderNodeRequest |
    FlowAnnotationNodeRequest;

function convertNodeToRequest(node: FlowNode): FlowNodeRequest {
    const { _id, ...nodeParams } = node;

    if ("createdAt" in nodeParams) {
        delete nodeParams.createdAt;
    }

    if (nodeParams.type === FlowNodeType.Screen) {
        return {
            ...nodeParams,
            screen: nodeParams.screen._id
        };
    }

    if (nodeParams.type === FlowNodeType.VariantGroup) {
        return {
            ...nodeParams,
            variantGroup: nodeParams.variantGroup._id
        };
    }

    return nodeParams;
}

export default FlowNodeRequest;
export {
    FlowScreenNodeRequest,
    FlowTextLabelNodeRequest,
    FlowVariantGroupNodeRequest,
    FlowShapeNodeRequest,
    FlowPlaceholderNodeRequest,
    FlowAnnotationNodeRequest,
    convertNodeToRequest
};
